import { render, staticRenderFns } from "./PartnerPayments.vue?vue&type=template&id=7aba9702"
import script from "./PartnerPayments.vue?vue&type=script&lang=js"
export * from "./PartnerPayments.vue?vue&type=script&lang=js"
import style0 from "./PartnerPayments.vue?vue&type=style&index=0&id=7aba9702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports